module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/team-introduction-banner-image.0a3e180e.jpg";